export const CHURCH = { name: "Riverside Community Church", rhythmDays: 30 };

export const LEADERS = {
  monica: { id: "monica", first: "Monica", last: "Alvarez", photo: "/mock/monica.jpg", title: "Care Leader", people: 12, week: 6 },
  david: { id: "david", first: "David", last: "Okafor", photo: "/mock/david.jpg", title: "Pastor", people: 9, week: 7, prefix: "Pastor" },
  lena: { id: "lena", first: "Lena", last: "Park", title: "Care Leader", people: 7, week: 5 },
  james: { id: "james", first: "James", last: "Whitfield", title: "Care Leader", people: 9, week: 4 },
  ruth: { id: "ruth", first: "Ruth", last: "Anders", title: "Care Leader", people: 14, week: 0, quiet: "No care logged in 3 weeks" },
  marcus: { id: "marcus", first: "Marcus", last: "Bell", title: "Care Leader", people: 10, week: 3 },
  elaine: { id: "elaine", first: "Elaine", last: "Porter", title: "Care Leader", week: 5 },
  nate: { id: "nate", first: "Nate", last: "Ortiz", title: "Care Leader", week: 7 },
  beth: { id: "beth", first: "Beth", last: "Moran", title: "Care Leader", week: 6 },
  kofi: { id: "kofi", first: "Kofi", last: "Mensah", title: "Care Leader", week: 4 },
};

export const leaderName = (id) => {
  const l = LEADERS[id];
  return l ? `${l.prefix ? l.prefix + " " : ""}${l.first} ${l.last}` : "No one yet";
};

const pco = (email, address, birthday, since) => ({ email, address, birthday, since, synced: "2 hours ago" });

export const PEOPLE = {
  harold: {
    id: "harold", first: "Harold", last: "Pettersen", photo: "/mock/harold.jpg", age: 78, phone: "(555) 214-3398",
    status: "active", caregiver: "monica", alsoCaring: "Men's Breakfast team",
    reason: "Home from St. Luke's after hip surgery",
    need: { title: "Hip surgery recovery", kind: "Recovery", opened: "Opened Oct 22 by Pastor David" },
    next: { label: "Check in on his recovery", due: "Due today", tone: "today" },
    lastSeen: "Phone call 2 days ago",
    household: { name: "Pettersen household", summary: "Married to June · dad to Erik", members: [
      { name: "June Pettersen", rel: "Wife · lives with Harold" },
      { name: "Erik Pettersen", rel: "Son · lives in Denver" },
    ] },
    pco: pco("harold.pettersen@example.com", "412 Alder Lane", "March 9", "Member since 1994"),
    timeline: [
      { type: "phone", who: "Monica Alvarez", when: "Thu, Oct 29", text: "Pain is a little better. Physical therapy starts Monday. June sounded tired — the Men's Breakfast guys are bringing dinner Saturday." },
      { type: "visit", who: "Pastor David", when: "Sun, Oct 25", text: "Visited at St. Luke's after surgery. Prayed with Harold and June. Discharge expected Tuesday." },
      { type: "need", who: "Pastor David", when: "Thu, Oct 22", text: "Started care for hip surgery recovery and asked Monica to own the follow-up." },
      { type: "text", who: "Monica Alvarez", when: "Tue, Oct 20", text: "Let Harold know we're praying for Thursday's surgery." },
    ],
    confidential: [
      { who: "Pastor David", when: "Sun, Oct 25", text: "Harold shared that he's afraid of falling again and hasn't told June how anxious he's been since the surgery. He asked me to keep this between us for now. I'll follow up in person next week." },
    ],
  },
  grace: {
    id: "grace", first: "Grace", last: "Kim", photo: "/mock/grace.jpg", age: 44, phone: "(555) 301-7724",
    status: "active", caregiver: "monica", alsoCaring: "Grief Care team",
    reason: "Her mother, Soon-ja, passed away 9 days ago",
    need: { title: "Loss of her mother", kind: "Grief", opened: "Opened Oct 22 by Monica" },
    next: { label: "Call to see how this week is going", due: "Due today", tone: "today" },
    lastSeen: "Visit 6 days ago",
    household: { name: "Kim household", summary: "Married to Daniel · mom to Noah and Ellie", members: [
      { name: "Daniel Kim", rel: "Husband" }, { name: "Noah Kim", rel: "Son · 12" }, { name: "Ellie Kim", rel: "Daughter · 9" },
    ] },
    pco: pco("grace.kim@example.com", "88 Willow Court", "June 14", "Member since 2016"),
    timeline: [
      { type: "visit", who: "Monica Alvarez", when: "Sun, Oct 25", text: "Brought a meal after the funeral. Grace is holding up for the kids, but the evenings are hard. Daniel goes back to work Monday." },
      { type: "need", who: "Monica Alvarez", when: "Thu, Oct 22", text: "Started grief care after Soon-ja's passing." },
    ],
    confidential: [],
  },
  tomas: {
    id: "tomas", first: "Tomás", last: "Rivera", photo: "/mock/tomas.jpg", age: 36, phone: "(555) 482-1190",
    status: "active", caregiver: "monica", alsoCaring: null,
    reason: "In his second week of chemotherapy",
    need: { title: "Cancer treatment", kind: "Illness", opened: "Opened Oct 12 by Pastor David" },
    next: { label: "Ask how treatment is going and if Ana needs help with Mateo", due: "Was due Thursday", tone: "past" },
    lastSeen: "Text 5 days ago",
    household: { name: "Rivera household", summary: "Married to Ana · dad to Mateo", members: [{ name: "Ana Rivera", rel: "Wife" }, { name: "Mateo Rivera", rel: "Son · 4" }] },
    pco: pco("tomas.rivera@example.com", "1907 Cedar Street", "August 2", "Attending since 2021"),
    timeline: [
      { type: "text", who: "Monica Alvarez", when: "Mon, Oct 26", text: "Tomás said the first week wiped him out. Ana could use someone to watch Mateo on Wednesday afternoons." },
      { type: "need", who: "Pastor David", when: "Mon, Oct 12", text: "Started care after Tomás's diagnosis." },
    ],
    confidential: [],
  },
  hannah: {
    id: "hannah", first: "Hannah", last: "Lindqvist", photo: "/mock/hannah.jpg", age: 31, phone: "(555) 620-4451",
    status: "active", caregiver: "monica", alsoCaring: "New Families team",
    reason: "Baby Elsie arrived Oct 26 — meals start Monday",
    need: { title: "New baby", kind: "New baby", opened: "Opened Oct 27 by Monica" },
    next: { label: "Confirm the meal schedule", due: "Monday", tone: "later" },
    lastSeen: "Text yesterday",
    household: { name: "Lindqvist household", summary: "Married to Oskar · mom to baby Elsie", members: [{ name: "Oskar Lindqvist", rel: "Husband" }, { name: "Elsie Lindqvist", rel: "Daughter · 5 days" }] },
    pco: pco("hannah.l@example.com", "5 Harbor View", "January 30", "Member since 2023"),
    timeline: [{ type: "text", who: "Monica Alvarez", when: "Fri, Oct 30", text: "Everyone is home and healthy. Meals Monday, Wednesday and Friday." }],
    confidential: [],
  },
  ben: {
    id: "ben", first: "Ben", last: "Carter", age: 52, phone: "(555) 733-0182",
    status: "active", caregiver: "monica", alsoCaring: null,
    reason: "Lost his job at the plant in October",
    need: { title: "Job loss", kind: "Life change", opened: "Opened Oct 9 by Monica" },
    next: { label: "Coffee check-in", due: "Thursday", tone: "later" },
    lastSeen: "In person 8 days ago",
    household: { name: "Carter household", summary: "Married to Dana", members: [{ name: "Dana Carter", rel: "Wife" }] },
    pco: pco("ben.carter@example.com", "301 Mill Road", "May 21", "Member since 2009"),
    timeline: [{ type: "in_person", who: "Monica Alvarez", when: "Fri, Oct 23", text: "Talked after the men's group. He has two interviews lined up. Encouraged." }],
    confidential: [],
  },
  eleanor: {
    id: "eleanor", first: "Eleanor", last: "Brooks", photo: "/mock/eleanor.jpg", age: 84, phone: "(555) 118-2047",
    status: "rhythm", caregiver: "monica", alsoCaring: null,
    reason: "Lives alone since Walt passed in the spring",
    rhythm: "It's been 41 days since anyone connected",
    next: { label: "Ready for a check-in", due: "Ready for a check-in", tone: "rhythm" },
    lastSeen: "Phone call 41 days ago",
    household: { name: "Brooks household", summary: "Widowed · lives alone", members: [] },
    pco: pco("—", "77 Orchard Way", "February 3", "Member since 1968"),
    timeline: [{ type: "phone", who: "Monica Alvarez", when: "Sun, Sep 20", text: "Eleanor loved the bulletin with the photo of the choir. Her eyesight is getting worse — a large-print bulletin would help." }],
    confidential: [],
  },
  frank: { id: "frank", first: "Frank", last: "Delgado", age: 67, status: "rhythm", reason: "Retired this summer after 30 years at the post office", caregiver: "monica", lastSeen: "Visit 12 days ago", next: { due: "In 18 days", tone: "later" }, household: { name: "Delgado household", members: [{ name: "Rosa Delgado", rel: "Wife" }] } },
  kwame: { id: "kwame", first: "Kwame", last: "Osei", age: 71, status: "rhythm", reason: "Ushers most Sundays; Abena has limited mobility", caregiver: "monica", lastSeen: "In person 16 days ago", next: { due: "In 14 days", tone: "later" }, household: { name: "Osei household", members: [{ name: "Abena Osei", rel: "Wife" }] } },
  lucy: { id: "lucy", first: "Lucy", last: "Tran", age: 29, status: "rhythm", reason: "New to Riverside this year", caregiver: "monica", lastSeen: "Text 21 days ago", next: { due: "In 9 days", tone: "later" }, household: { name: "Tran household", members: [] } },
  patricia: { id: "patricia", first: "Patricia", last: "Wells", age: 58, status: "rhythm", reason: "Leads the Tuesday prayer group", caregiver: "monica", lastSeen: "Phone call 4 days ago", next: { due: "In 26 days", tone: "later" }, household: { name: "Wells household", members: [{ name: "Gary Wells", rel: "Husband" }] } },
  sam: { id: "sam", first: "Sam", last: "Whitaker", age: 19, status: "rhythm", reason: "First semester away at college", caregiver: "monica", lastSeen: "Text 25 days ago", next: { due: "In 5 days", tone: "later" }, household: { name: "Whitaker household", members: [{ name: "Joan Whitaker", rel: "Mother" }] } },
  marjorie: { id: "marjorie", first: "Marjorie", last: "Hale", age: 90, status: "paused", reason: "Now attends her daughter's church in Ohio", caregiver: "monica", lastSeen: "Visit 3 days ago", next: { due: "Cared for by her family's church", tone: "later" }, household: { name: "Hale household", members: [] } },
  walter: {
    id: "walter", first: "Walter", last: "Hughes", photo: "/mock/walter.jpg", age: 81, phone: "(555) 902-6613",
    status: "active", caregiver: "david", alsoCaring: "Elders",
    reason: "Began hospice care at home this week",
    need: { title: "Hospice care", kind: "End of life", opened: "Opened Oct 27 by Pastor David" },
    next: { label: "Visit and bring communion", due: "Due today", tone: "today" },
    lastSeen: "Visit 4 days ago",
    household: { name: "Hughes household", summary: "Married to Ida · dad to Carol", members: [{ name: "Ida Hughes", rel: "Wife" }, { name: "Carol Jenkins", rel: "Daughter" }] },
    pco: pco("w.hughes@example.com", "19 Birch Hollow", "October 4", "Member since 1972"),
    timeline: [{ type: "visit", who: "Pastor David", when: "Tue, Oct 27", text: "Walter is comfortable and at peace. Ida asked about planning the service — follow up gently next visit." }],
    confidential: [],
  },
  naomi: {
    id: "naomi", first: "Naomi", last: "Ford", age: 39, phone: "(555) 554-8890",
    status: "active", caregiver: "david", alsoCaring: null,
    reason: "Asked to meet with a pastor",
    need: { title: "Pastoral conversation", kind: "Spiritual", opened: "Opened Oct 29 by Pastor David" },
    next: { label: "Schedule a time to meet", due: "Was due yesterday", tone: "past" },
    lastSeen: "Email 3 days ago",
    household: { name: "Ford household", summary: "Married to Chris", members: [{ name: "Chris Ford", rel: "Husband" }] },
    pco: pco("naomi.ford@example.com", "640 Elm Street", "April 17", "Member since 2018"),
    timeline: [{ type: "email", who: "Pastor David", when: "Wed, Oct 28", text: "Replied to Naomi's note and offered a few times next week." }],
    confidential: [],
  },
};

export const TODAY_PLAN = {
  leader: { attention: ["tomas", "harold", "grace"], moment: "eleanor", upcoming: ["hannah", "ben"] },
  pastor: { attention: ["naomi", "walter"], moment: null, upcoming: [] },
};

export const MY_PEOPLE = ["harold", "grace", "tomas", "hannah", "ben", "eleanor", "sam", "lucy", "kwame", "frank", "patricia", "marjorie"];
export const ALL_PEOPLE = [...MY_PEOPLE, "walter", "naomi"];

const HINTS = {
  active: "Someone is walking with them through something right now.",
  rhythm: "Part of your normal care rhythm — a regular, meaningful touch.",
  paused: "Intentionally left out of routine reminders.",
};
const statusSet = (a, r, p) => ({
  active: { label: a, tone: "brand", hint: HINTS.active },
  rhythm: { label: r, tone: "neutral", hint: HINTS.rhythm },
  paused: { label: p, tone: "neutral", hint: HINTS.paused },
});
export const STATUS_SETS = {
  A: statusSet("Active care", "Staying connected", "Not tracked"),
  B: statusSet("Active care", "Regular care", "Not in reminders"),
  C: statusSet("Needs care now", "Ongoing care", "Paused"),
};

export const OVERVIEW = {
  unassigned: [
    { id: "foss-move", name: "Wendell & Marie Foss", reason: "Moving into assisted living — their daughter asked for a visit", since: "Shared 2 days ago" },
    { id: "joy", name: "Joy Martins", reason: "Prayer card: her husband has heart surgery Thursday", since: "Shared yesterday" },
    { id: "luis", name: "Luis Ortega", reason: "New to Riverside and recently widowed", since: "Shared 3 days ago" },
  ],
  pastDue: [
    { id: "pd1", name: "Carol Jenkins", leader: "ruth", due: "Was due 6 days ago" },
    { id: "pd2", name: "Tomás Rivera", leader: "monica", due: "Was due 2 days ago" },
    { id: "pd3", name: "Peter Lang", leader: "ruth", due: "Was due 9 days ago" },
    { id: "pd4", name: "Ana Sofia Diaz", leader: "james", due: "Was due yesterday" },
  ],
  outside: [
    { id: "o1", name: "Eleanor Brooks", leader: "monica", days: 41 },
    { id: "o2", name: "Gerald Fenn", leader: "ruth", days: 52 },
    { id: "o3", name: "Mei Lin Zhou", leader: "james", days: 38 },
    { id: "o4", name: "Thomas & Bea Arnold", leader: "ruth", days: 35 },
    { id: "o5", name: "Doris Kemp", leader: "marcus", days: 63 },
    { id: "o6", name: "Abe Lindgren", leader: "ruth", days: 71 },
    { id: "o7", name: "Priya Nair", leader: "lena", days: 22 },
    { id: "o8", name: "Owen Pratt", leader: "james", days: 18 },
    { id: "o9", name: "Celia Ward", leader: "marcus", days: 27 },
  ],
  teams: [
    { name: "Hospital & Recovery", lead: "lena", leaders: 4, people: 11 },
    { name: "Grief Care", lead: "david", leaders: 3, people: 6 },
    { name: "Senior Saints", lead: "monica", leaders: 5, people: 38 },
    { name: "New Families", lead: "james", leaders: 3, people: 9 },
  ],
  trend: [31, 28, 35, 33, 40, 37, 42, 44].map((v, i) => ({ w: i, v })),
};
